// Settings

import $ from 'jquery'
window.$ = window.jQuery = $

// Globals

import '../elements/_partials/menu.js'
import '../elements/_partials/currency-switcher.js'
import '../elements/_partials/cookie-consent.js'
import '../elements/_partials/scroll-down.js'
import '../elements/_partials/scroll-to-top.js'

// Page specified scripts

// Unused scripts

// WIP scripts
